<template>
  <div class="row">

    <div class="col-md-12 text-right">
      <b-dropdown variant="primary" id="dropdown-1" text="Share & Export" class="mb-2">
        <b-dropdown-item>Share to the web</b-dropdown-item>
        <b-dropdown-item>Export to Pdf</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="col-md-12" v-for="module in displayData" :key="module.id">

      <div class="card">
        <div class="card-header"><h5>{{ module.title }}</h5></div>
        <div class="card-body">

          <div class="list-group" v-for="main in module.mainSteps" style="margin-bottom: 30px" :key="main.id"
               v-if="main.original.in_export">
            <div class="list-group-item flex-column align-items-start active list-group-item-action active">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1" style="color: white">{{ main.original.translation[locale].name }}</h5>
              </div>
            </div>
            <div class="list-group-item flex-column align-items-start list-group-item-action"
                 v-for="sub in main.subSteps" :key="sub.id">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-1">{{ sub.original.translation[locale].name }}</h6>
              </div>
              <p class="mb-1" v-html="sub.description" v-if="sub.original.in_export && sub.is_active == 3"></p>
              <p class="mb-1" v-if="sub.original.in_export && sub.is_active != 3"><i style="color: red">=== Answer will
                be available after approve from mentor ===</i></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PlanSummary',
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    },
    planSteps: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {},
  mounted() {

    this.project.steps.forEach((item) => {
      item.original = this.planSteps.find((record) => {
        return record.id == item.original_id
      })
    })

    this.modules.forEach((module) => {

      let mainSteps = this.project.steps.filter((item) => {
        return item.original != undefined && item.original && item.original.parent_id == module.id
      })

      if (mainSteps.length) {

        module.mainSteps = mainSteps

        mainSteps.forEach((category) => {

          let other = this.project.steps.filter((item) => {
            return item.original != undefined && item.original.parent_id == category.original.id
          })

          category.subSteps = other
        })
      }
    })

    this.$set(this, 'displayData', this.modules)
  },
  data() {
    return {
      displayData: [],
      modules: [
        {
          "id": 1,
          "title": "How to come up with a successful business idea?"

        },
        {
          "id": 2,
          "title": "What makes a business worthwhile and how to measure it?"
        },
        {
          "id": 3,
          "title": "How Does a Business Work?"
        },
        {
          "id": 4,
          "title": "How to get money and how to spend money?"
        },
        {
          "id": 5,
          "title": "What could go wrong and how to avoid it?"
        },
        {
          "id": 6,
          "title": "How to present the business to others?"
        },
        {
          "id": 7,
          "title": "You Only Make a First Impression Once"
        },
        {
          "id": 8,
          "title": "How to make business bigger and better"
        }
      ]
    }
  },
  methods: {},
  computed: {
    locale: function () {
      return this.$i18n.locale
    },
  }
};
</script>
